import React from 'react';

const ArrowIcon = ({ onClick }) => (
  <svg 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg" 
    fill="#000000"
    style={{ 
      width: '2rem',
      marginTop: '3rem', 
      height: 'auto', 
      cursor: 'pointer', 
      animation: 'bounce 2s infinite'
    }}
    onClick={onClick}
  >
    <polyline 
      fill="none" 
      points="7 16.4 12 21.5 17 16.4" 
      stroke="white" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth="2"
    />
    <line 
      fill="none" 
      stroke="white" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth="2" 
      x1="12" 
      x2="12" 
      y1="2.5" 
      y2="19.2"
    />
  </svg>
);

export default ArrowIcon;
